import { useContext, useState } from "react";
import { FloatingCheckValue, RdContextType } from "../../@types/Rd";
import RdContext from "../../contexts/RdProvider";
import { isAuthorized } from "../../Hooks/isUserAuthorized";
import FloatingCheck from "../CustomFloatingCheck/Component";
import React from "react";
import { Container, Dropdown } from "react-bootstrap";


const MasterSelectorActivate = (): JSX.Element | null => {

    const { IsMasterActive, ChangeMasterActivity, userInfo } = useContext<RdContextType>(RdContext),
        canEnableMaster: boolean = (userInfo?.IsMaster != null && userInfo.IsActive && userInfo.IsMaster) && isAuthorized("Admin");

    return !canEnableMaster ?
        null :
        <Container fluid className="fullWidth">
            <FloatingCheck
                id="MasterActivity"
                label="Master"
                group={{ className: "horizontalAlignment" }}
                initialValue={IsMasterActive as any}
                valueHandle={(value: FloatingCheckValue) => {
                    const enable: boolean = value as any;
                    ChangeMasterActivity(enable);
                }}

                type="switch"
                title="Ativar/Desativar Açoes de Master."
            />
            <Dropdown.Divider />
        </Container>
        ;
}

export default MasterSelectorActivate